import { gsap } from "gsap";
import { Global } from "./../global";

export const LineModal = {
  /**
   * funcs
   */
  init: function() {
    if(Global.isLineModal){
      document.querySelector('.lineModal-box .close').addEventListener('click', function(){
        gsap.to("#l-lineModal",.4,{autoAlpha:0,
          onStart:()=>{
            Global.isLineModal=false;
          },
          onComplete:()=>{
            Global.lineModal.remove()
        }})
      })
    }
  },
  fadeIn:()=>{
    Global.lineModal.classList.add("is-active")
    gsap.to("#l-lineModal",.4,{autoAlpha:1})
  },
};
